/* Кабинет оператора: карточка «Холд» под «К выплате» (16.10.2026, владелец: оператор видит свой холд «в кабинете
   и в расчётке»). Холд — на сегодня, от периода не зависит: заработано за закрытые недели − выдано (GET /api/payouts/my).
   «+» — мы вам должны, «−» — вы нам должны (переплата, учтётся при следующей выдаче). Ошибка загрузки — карточки нет. */
import { useEffect, useState } from "react";
import { api } from "../../api/client";
import { orenStamp, rub, signedRub } from "../../hooks/payoutsApi";
import css from "./holdCard.module.css";

interface My { hold: number; payouts: { id: number; amount: number; paid_at: string; comment: string }[] }

export function HoldCard() {
  const [my, setMy] = useState<My | null>(null);
  useEffect(() => {
    let alive = true;
    api<My>("/api/payouts/my").then((r) => { if (alive) setMy(r); }, () => { if (alive) setMy(null); });
    return () => { alive = false; };
  }, []);
  if (!my) return null;
  const h = my.hold;
  const tone = h > 0 ? css.owe : h < 0 ? css.debt : css.zero;
  return (
    <div className={`${css.card} ${tone}`}>
      <div className={css.head}><span className={css.lbl}>Холд</span><span className={css.sum}>{signedRub(h)}</span></div>
      <div className={css.text}>{h > 0 ? "Мы вам должны — выдадим" : h < 0 ? "Вы нам должны — учтём при следующей выдаче" : "В расчёте"}</div>
      {my.payouts.slice(0, 3).map((p) => <div key={p.id} className={css.pay}>Выдано {orenStamp(p.paid_at)}: {rub(p.amount)}{p.comment ? ` · ${p.comment}` : ""}</div>)}
      <div className={css.foot}>На сегодня: заработано за закрытые недели минус выданное</div>
    </div>
  );
}
